export default function ExtraDaysWarning (props) {
  const {
    show,
    allowInAdvance,
    holidayInAdvanceEnabled,
    onHolidayInAdvanceChange
  } = props

  if (!show) return null

  return (
    <div className='event-form-extra-days-warning'>
      <p className='event-form-extra-days-warning__text'>
        {I18n.t('calendar.holiday_entitlements.extra_days_hint')}
      </p>
      {allowInAdvance && (
        <label className='event-form-extra-days-warning__checkbox'>
          <input
            type='checkbox'
            checked={holidayInAdvanceEnabled}
            onChange={onHolidayInAdvanceChange}
          />
          {' '}
          {I18n.t('calendar.actions.request_vacation_in_advance')}
        </label>
      )}
    </div>
  )
}
